// These are used in the url.
// If we change them, we'll break any existing urls unless we add migration logic.
export enum URLParam {
    DataSource = 'src',
    UpdateParams = 'u_params',
    Table = 't',
    GroupBy = 'g',
    SortBy = 's',
    Filters = 'f',
    Version = 'v',
}